<div class="page_wrapper">
    <div class="full_bg">
        <section class="signup_section">
            <div class="container">

                <div class="top_part">
                    <a *ngIf="currentStep > 1" (click)="goToSignUp()" class="back_btn" style="cursor: pointer;">
                        <i class="fa fa-arrow-left"></i> Back to Sign Up
                    </a>
                    <a class="navbar-brand" (click)="goToHome()" style="cursor: pointer;">
                        <img src="assets/images/auth/logo.png" alt="ShiftClock Logo">
                    </a>
                </div>

                <div class="form_block">

                    <div class="side_screen">
                        <div class="section_title">
                            <h2>Sign Up & Manage Your Shifts Effortlessly!</h2>
                            <p>Easily schedule shifts, track employee hours, and manage your workforce efficiently with ShiftClock — the smart solution for modern businesses.</p>
                        </div>

                        <div class="scrren">
                            <img src="assets/images/auth/sign-up-img.png" alt="Sign Up Illustration">
                        </div>
                    </div>

                    <div class="form_side">
                        <div class="section_title">
                            <span class="title_badge">Get Started</span>
                            <h4>Create an account</h4>
                            <p>Register with us to get started.</p>
                        </div>

                        <!-- Progress Steps Indicator -->
                        <div class="steps-indicator mb-4">
                            <div class="step" [class.active]="currentStep >= 1" [class.completed]="currentStep > 1">
                                <div class="step-circle">1</div>
                                <span class="step-label">Contact</span>
                            </div>
                            <div class="step-line" [class.active]="currentStep > 1"></div>
                            <div class="step" [class.active]="currentStep >= 2" [class.completed]="currentStep > 2">
                                <div class="step-circle">2</div>
                                <span class="step-label">Company</span>
                            </div>
                            <div class="step-line" [class.active]="currentStep > 2"></div>
                            <div class="step" [class.active]="currentStep >= 3">
                                <div class="step-circle">3</div>
                                <span class="step-label">Security</span>
                            </div>
                        </div>

                        <!-- Step Content -->
                        <form [formGroup]="signupForm">
                            <!-- Step 1: Email & Phone -->
                            <app-signup-step-one 
                                *ngIf="currentStep === 1"
                                [formGroup]="signupForm"
                                (nextStep)="nextStep()"
                            ></app-signup-step-one>

                            <!-- Step 2: Company & Industry -->
                            <app-signup-step-two 
                                *ngIf="currentStep === 2"
                                [formGroup]="signupForm"
                                (nextStep)="nextStep()"
                                (previousStep)="previousStep()"
                            ></app-signup-step-two>

                            <!-- Step 3: Password & Terms -->
                            <app-signup-step-three 
                                *ngIf="currentStep === 3"
                                [formGroup]="signupForm"
                                [isLoading]="isLoading"
                                (submit)="onSubmit()"
                                (previousStep)="previousStep()"
                            ></app-signup-step-three>
                        </form>

                        <div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
                            {{ errorMessage }}
                        </div>

                        <div *ngIf="successMessage" class="alert alert-success mt-3" role="alert">
                            {{ successMessage }}
                        </div>

                    </div>

                </div>

            </div>
        </section>
    </div>
</div>